exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Home__home___20mOJ {\n  max-width: 700px;\n  padding: 0 16px;\n}\n\n.Home__letsGo___1IByQ {\n  -ms-flex-item-align: center;\n      align-self: center;\n  margin-top: 24px;\n  width: 250px;\n}\n", ""]);

// exports
exports.locals = {
	"home": "Home__home___20mOJ",
	"letsGo": "Home__letsGo___1IByQ"
};